// True while a Quote Brain run is live on this job (Peter's O1, 2026-10-28):
// the Quote Brain is writing the quote, so Stage 4 and Stage 5 leave its items
// alone until it finishes. Follows the run banner's mark
// (src/utils/quote-brain-project.ts markQuoteBrainRunLive).
import { useSyncExternalStore } from 'react';
import { getQuoteBrainJobRulesVersion, isQuoteBrainRunLive, subscribeQuoteBrainJobRules } from '../utils/quote-brain-project';

export function useQuoteBrainWriting(projectId: unknown): boolean {
    useSyncExternalStore(subscribeQuoteBrainJobRules, getQuoteBrainJobRulesVersion, getQuoteBrainJobRulesVersion);
    return projectId != null && projectId !== '' && isQuoteBrainRunLive(projectId);
}
